<template>
  <MetricCard
    apiEndpoint="/tiktok/engagement"
    metricName="Total Engagements"
    :formatData="formatData"
    srcName="TikTok"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';
import { formatNumber } from '@/utils/helperFunctions';
const formatData = (data) => formatNumber(data.data);
</script>
